import Bloc from '../Bloc/Bloc'
import { formatNb } from 'functions'
import style from './StateData.module.scss'
import Loading from '../graphs/Loading/Loading'

const StateData = ({ title, data, size, footerTitle, hidePast }) => {

  return ( 
    <Bloc
      title={title}
      size={size ?? 'tier'}
      content={
        data === null
        ? <Loading height={'65px'} />
        : <>
          <span className={style.mainNb}>{formatNb(data.main)}</span>
          {!hidePast && <footer className={style.progress}>
            { footerTitle } {formatNb(data.past)}
            <span className={data.progress > 0 ? style.better : style.worst}>
              {data.progress > 0 && '+'}{Math.round(data.progress * 10) / 10}%
            </span>
          </footer>}
        </>
      }
    />
  )
}

export default StateData
